// extracted by mini-css-extract-plugin
module.exports = {"listMain":"PlatFormList_listMain__krfEo","loading":"PlatFormList_loading___m8VI"};